import React from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, useLocation } from 'react-router-dom';
import WaitlistDepositBlock from '../../components/marketing/WaitlistDepositBlock';
import { readWaitlistRef } from '../../services/waitlistService';
import { WAITLIST_DEPOSIT } from '../content/waitlist';
import MarketingLayout from '../layout/MarketingLayout';

function refFromState(state: unknown): string | null {
  if (state && typeof state === 'object' && 'ref' in state) {
    const { ref } = state as { ref: unknown };
    return typeof ref === 'string' && ref ? ref : null;
  }
  return null;
}

/**
 * Where a popup signup lands: the same deposit step the inline forms show,
 * on its own page so Stripe never runs inside a popup. The ref comes from the
 * navigation, or from this tab's storage after a reload. With neither there
 * is no entry to pay against, so the visitor goes to the waitlist instead.
 */
export default function WaitlistDepositPage() {
  const location = useLocation();
  const entryRef = refFromState(location.state) ?? readWaitlistRef();

  if (!entryRef) return <Navigate to="/waitlist" replace />;

  return (
    <MarketingLayout activePage="home">
      <Helmet>
        <title>{`${WAITLIST_DEPOSIT.heading} · Melio`}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <section className="mk-wl">
        <div className="mk-container mk-wl__grid">
          <div className="mk-wl__form">
            <WaitlistDepositBlock entryRef={entryRef} titleAs="h1" />
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
